import { useLanguage } from "../../hooks";

function getDefaultLanguage() {
  return import.meta.env.VITE_DEFAULT_LANGUAGE;
}

function LanguageItem(props) {
  const { language } = useLanguage();

  if (language in props || (!language && getDefaultLanguage() in props)) {
    return props.children;
  }
}

export default LanguageItem;
